import {Id} from './types';

export class Notification {
  id: Id;
  date: Date;
  title: string;
  message: string;
  seen: boolean;
}
